// extracted by mini-css-extract-plugin
module.exports = {"XS":"360px","SM":"640px","MD":"1024px","LG":"1280px","XL":"1440px","xxl":"1920px","Pagination":"Pagination_Pagination__2A3-f"};